import React from 'react'
import { Link } from 'react-router-dom'
import VideoModal from '../../components/ModalVideo'


const About = (props) => {
    const ClickHandler = () =>{
        window.scrollTo(10, 0);
     }
    return(
        <div className={`wpo-about-area section-padding ${props.abClass}`}>
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-lg-5 col-md-12 col-sm-12">
                        <div className="wpo-about-img">
                            <img src={props.abimg} alt=""/>
                        </div>
                    </div>
                    <div className="col-lg-7 col-md-12 colsm-12">
                        <div className="wpo-about-text">
                            <div className="wpo-about-title">
                                <span>À Propos de Get Riad</span>
                                <h2>Acquérir un Riad authentique, le rénover ou concevoir un projet sur-mesure,</h2>
                            </div>
                        <h5>Chez Get Riad, spécialisés dans la vente, l'achat, la construction et la rénovation de Riads à Marrakech. </h5>
                        <p> Avec notre expertise et notre passion pour l'architecture marocaine, nous créons des espaces uniques qui allient tradition et modernité.</p>
                            <div className="btns">
                                <Link to="/about" onClick={ClickHandler} className="theme-btn">Découvrez Plus</Link>
                                <ul>
                                    <li className="video-holder">
                                        <VideoModal/>
                                    </li>
                                    <li className="video-text">
                                    Ragardez Notre Vidéo
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default About;